import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";
import { map, tap } from "rxjs/operators";
import { Spinner } from "src/app/core/services/spinner.service";
import { ContractService } from "src/app/modules/contracts/services/contract.service";
@Injectable({
  providedIn: "root"
})
export class ContractUserService {
  constructor(private spinner: Spinner, private httpClient: HttpClient) {}

  exportUsers() {
    this.spinner.show();
    const url = ContractService.CONTRACT_MODULE_BASE_URL + "/contract/user/export";
    const fileData$ = this.httpClient.get<Blob>(url, {
      observe: "response",
      responseType: "blob" as "json"
    });
    return fileData$.pipe(
      tap(response => {
        const contentDisposition = response.headers.get("content-disposition");
        const filename = this.extractFileName(contentDisposition);
        console.log(filename);
        FileSaver.saveAs(response.body, filename);
        this.spinner.hide();
      }),
      map(() => {
        return;
      })
    );
  }

  private extractFileName(contentDisposition: string) {
    return contentDisposition
      .split(";")[1]
      .split("filename")[1]
      .split("=")[1]
      .trim()
      // Remove unnecessary double quotes from server    
      .replace(/"/g, "");
  }
}
